const workData = [
  {
    title: "Data Entry Operator at Block Land and Land Reforms Office",
    company: "Block Land and Land Reforms Office, Govt. of West Bengal",
    location: "Haldia, West Bengal, India",
    role: "Data Entry Operator",
    duration: "March, 2025 - August, 2026",
  },
  {
    title: "Associate Software Engineer at Think Hat Business Solutions",
    company: "Think Hat Business Solutions",
    location: "Kolkata, West Bengal, India",
    role: "Associate Software Engineer",
    duration: "July, 2024 - February, 2025",
  },
  {
    title: "Employment at Bestman Exceed Software LLP",
    company: "Bestman Exceed Software LLP",
    location:
      "FD-84, Sector-III, Salt Lake City Kolkata-700 106, West Bengal, India",
    role: "Website design, Sales and marketing, Technical support",
    duration: "February, 2024 - July, 2024",
    learning: [
      "I have learnt how to build my connections and networks.",
      "I have worked on the live websites of some clients.",
      "I have communicated with different people from different locations in India as technical support was one of my roles. So that my communication skill has improved.",
    ],
  },
];

export default workData;
